// Simple i18n dictionary for EN / FR / NL
export const translations = {
  EN: {
    nav: {
      new_projects: 'NEW PROJECTS',
      for_sale: 'FOR SALE',
      for_rent: 'FOR RENT',
      who: 'WHO WE ARE',
      management: 'MANAGEMENT',
      contact: 'CONTACT'
    },
    hero: {
      brand: 'IMODEFF',
      title: 'Commercial & Residential Projects in Belgium',
      tagline: 'Family Office · Since 1991',
      featured: 'Featured',
      developer: 'Real Estate Developer',
      developer_since: 'SINCE 2010',
      investor: 'Real Estate Investor',
      investor_since: 'SINCE 1990',
      cta_projects: 'Discover our projects',
      cta_contact: 'Contact us'
    },
    sections: {
      who: 'WHO WE ARE',
      who_text: 'Imodeff is a family office specialised in the purchase, development and management of prestigious properties throughout Belgium and abroad. Founded and run by the Hodjeff family, we invest our own patrimony alongside that of our partners, buy up heritage assets and create long-term value in high-potential urban environments.',
      vision: 'OUR VISION',
      vision_text: 'Our buy-out, construction and renovation projects are selected with the utmost care and are part of our vision of sustainable real estate, favouring renewable techniques and materials with low energy impact while contributing to the biodiversity of the urban environment.',
      latest: 'OUR LATEST PROJECTS',
      activities: 'OUR ACTIVITIES',
      easywork_title: 'Easywork: coworking & business office',
      easywork_text: 'Highly flexible coworking spaces in a green and home environment a few steps from the Brussels ring.',
      view_more: 'View more',
      view_project: 'View project',
      browse_all: 'Browse all projects',
      team: 'OUR TEAM',
      mission: 'OUR MISSION',
      mission_text: 'Investing, developing and creating real estate projects that respect the architectural heritage and our values of excellence. We develop exceptional residential and commercial spaces and manage these properties for sale and rent.',
      experience: '30 YEARS OF EXPERIENCE',
      experience_text: 'We have been investing in residential and commercial projects that are renowned for their architecture, location and quality of construction since 1991. Through our investments and expertise, we actively contribute to the dynamism and development of architectural wealth.',
      human_team: 'A HUMAN TEAM AT YOUR SERVICE',
      human_team_text: 'Imodeff is a company on a human scale that guarantees in-depth knowledge of the real estate sector and a personalised follow-up of each project. Whether you are a seller or a buyer, we put our 30 years of expertise at your service.',
      contact_us: 'CONTACT US',
      contact_intro: 'We will happily answer all your questions.',
      find_us: 'FIND US',
      who_headline: 'A family office at the service of Belgian real estate',
      portfolio_label: 'OUR PORTFOLIO',
      email_label: 'EMAIL',
      phone_label: 'PHONE',
      address_label: 'ADDRESS'
    },
    activities: {
      development: 'Real Estate Development',
      development_text: 'By combining design, technology, durability and a high level of finish, all our buildings aim to offer the greatest comfort to their future occupants.',
      investment: 'Real Estate Investment',
      investment_text: 'Discover our properties currently being managed.',
      sales: 'Real Estate Sales',
      sales_text: 'Discover our properties for sale.',
      rentals: 'Real Estate Rentals',
      rentals_text: 'Discover our properties for rent.'
    },
    form: {
      first: 'First Name',
      last: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      submit: 'Submit',
      success: 'Thanks for submitting!',
      error: 'Something went wrong. Please try again.'
    },
    footer: {
      contact: 'Contact',
      address: 'Address',
      copyright: '© 2025 Imodeff. All rights reserved.'
    },
    listing: {
      empty: 'No properties available in this category yet.',
      surface: 'Surface',
      units: 'Units',
      year: 'Year',
      architect: 'Architect',
      features: 'Features',
      request_info: 'Request information',
      back: 'Back to projects',
      details: 'DETAILS',
      not_found: 'Project not found.',
      status_rented: 'Rented',
      status_sold: 'Sold',
      status_price_on_demand: 'Price on demand',
      status_on_demand: 'On demand',
      status_coming_soon: 'Coming soon',
      status_price_on_request: 'Price on request'
    },
    management: {
      hero_label: 'PROPERTY MANAGEMENT',
      hero_title: 'Entrust your property to specialists',
      hero_text: 'As of today, we are also expanding our services to include full property management. Building on 30 years of expertise in real estate development and investment, Imodeff now takes care of your residential and commercial properties so that owning becomes serene.',
      cta: 'Get a personalised quote',
      services_label: 'OUR SERVICES',
      services_title: 'Day-to-day management of your rental property',
      services: [
        {
          title: 'Regular tasks',
          text: 'Everything you need for the day-to-day life of an already-let property.',
          items: [
            'Organising the signing of the lease',
            'Meter transfer',
            'Setting up / releasing the rental guarantee',
            'Tenant insurance',
            'Handing over of keys',
            'Rent payment verification',
            'Annual rent indexation',
            'Annual statement of rental charges'
          ]
        },
        {
          title: 'Supplementary tasks',
          text: 'Additional services to fully protect and maintain your property.',
          items: [
            'Planning small works, cleaning and painting',
            'Inventory carried out by an independent expert',
            'Claims management',
            'Litigation management',
            'Unpaid rent insurance'
          ]
        },
        {
          title: 'Activity report',
          text: 'Clear reporting so you always know how your property performs.',
          items: [
            'Quarterly rental situation report',
            'Analysis against relevant market data',
            'Profitability and yield indicators',
            'Dedicated point of contact'
          ]
        }
      ],
      process_label: 'HOW IT WORKS',
      process_title: 'A simple four-step process',
      process: [
        { step: '01', title: 'Discovery call', text: 'We discuss your property, your goals and expected yield.' },
        { step: '02', title: 'Property audit', text: 'Free on-site audit and market positioning to define the right rental price.' },
        { step: '03', title: 'Mandate signature', text: 'A transparent management mandate, tailored to your property.' },
        { step: '04', title: 'Turnkey management', text: 'We handle everything - you receive your net rent every month.' }
      ],
      fees_label: 'OUR APPROACH',
      fees_title: 'A tailor-made proposal',
      fees_text: 'Each mandate is designed to fit your specific needs and kept in the trusted hands of our family. Contact us to receive a personalised offer.',
      cta_section_title: 'Ready to hand over the keys?',
      cta_section_text: 'Our team will get back to you within 24 hours with a tailored proposal for your property.',
      badge_years: '30 YEARS',
      badge_tagline: 'Of trusted management',
      promise_label: 'OUR PROMISE',
      promise_title: 'Turnkey management, tailored to your property',
      promise_text: 'A dedicated team, curated craftsmen and a transparent process - so that owning becomes serene.',
      commitments: [
        'Quarterly reporting',
        'Personalised follow-up',
        'Cancel anytime with 3 months notice'
      ]
    }
  },
  FR: {
    nav: {
      new_projects: 'NOUVEAUX PROJETS',
      for_sale: 'À VENDRE',
      for_rent: 'À LOUER',
      who: 'QUI SOMMES-NOUS',
      management: 'GESTION',
      contact: 'CONTACT'
    },
    hero: {
      brand: 'IMODEFF',
      title: 'Projets commerciaux et résidentiels en Belgique',
      tagline: 'Family Office · Depuis 1991',
      featured: 'À l\u2019affiche',
      developer: 'Développeur Immobilier',
      developer_since: 'DEPUIS 2010',
      investor: 'Investisseur Immobilier',
      investor_since: 'DEPUIS 1990',
      cta_projects: 'Découvrir nos projets',
      cta_contact: 'Nous contacter'
    },
    sections: {
      who: 'QUI SOMMES-NOUS',
      who_text: 'Imodeff est une société immobilière spécialisée dans l’achat, le développement et la gestion de biens prestigieux à travers la Belgique et à l’étranger. Nous rachetons des entreprises patrimoniales et créons de la valeur ajoutée dans des environnements urbains à fort potentiel.',
      vision: 'NOTRE VISION',
      vision_text: 'Nos projets de rachat, de construction et de rénovation sont sélectionnés avec le plus grand soin et s’inscrivent dans notre vision d’un immobilier durable, favorisant les techniques renouvelables et les matériaux à faible impact énergétique.',
      latest: 'NOS DERNIERS PROJETS',
      activities: 'NOS ACTIVITÉS',
      easywork_title: 'Easywork : coworking & bureaux',
      easywork_text: 'Des espaces de coworking flexibles dans un environnement vert et convivial à quelques pas du ring de Bruxelles.',
      view_more: 'Voir plus',
      view_project: 'Voir le projet',
      browse_all: 'Voir tous les projets',
      team: 'NOTRE ÉQUIPE',
      mission: 'NOTRE MISSION',
      mission_text: 'Investir, développer et créer des projets immobiliers respectueux du patrimoine architectural et de nos valeurs d’excellence.',
      experience: '30 ANS D’EXPÉRIENCE',
      experience_text: 'Nous investissons depuis 1991 dans des projets résidentiels et commerciaux reconnus pour leur architecture, leur emplacement et leur qualité de construction.',
      human_team: 'UNE ÉQUIPE HUMAINE À VOTRE SERVICE',
      human_team_text: 'Imodeff est une entreprise à taille humaine qui garantit une connaissance approfondie du secteur immobilier et un suivi personnalisé de chaque projet.',
      contact_us: 'NOUS CONTACTER',
      contact_intro: 'Nous répondrons volontiers à toutes vos questions.',
      find_us: 'NOUS TROUVER',
      who_headline: 'Un family office au service de l\u2019immobilier belge',
      portfolio_label: 'NOTRE PORTEFEUILLE',
      email_label: 'E-MAIL',
      phone_label: 'TÉLÉPHONE',
      address_label: 'ADRESSE'
    },
    activities: {
      development: 'Développement Immobilier',
      development_text: 'En combinant design, technologie, durabilité et niveau de finition élevé, tous nos bâtiments visent à offrir le plus grand confort à leurs occupants.',
      investment: 'Investissement Immobilier',
      investment_text: 'Découvrez nos biens actuellement sous gestion.',
      sales: 'Ventes Immobilières',
      sales_text: 'Découvrez nos biens en vente.',
      rentals: 'Locations Immobilières',
      rentals_text: 'Découvrez nos biens à louer.'
    },
    form: {
      first: 'Prénom',
      last: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      message: 'Message',
      submit: 'Envoyer',
      success: 'Merci pour votre message !',
      error: 'Une erreur est survenue. Merci de réessayer.'
    },
    footer: {
      contact: 'Contact',
      address: 'Adresse',
      copyright: '© 2025 Imodeff. Tous droits réservés.'
    },
    listing: {
      empty: 'Aucun bien disponible dans cette catégorie pour le moment.',
      surface: 'Surface',
      units: 'Unités',
      year: 'Année',
      architect: 'Architecte',
      features: 'Caractéristiques',
      request_info: 'Demander des informations',
      back: 'Retour aux projets',
      details: 'DÉTAILS',
      not_found: 'Projet introuvable.',
      status_rented: 'Loué',
      status_sold: 'Vendu',
      status_price_on_demand: 'Prix sur demande',
      status_on_demand: 'Sur demande',
      status_coming_soon: 'Bientôt disponible',
      status_price_on_request: 'Prix sur demande'
    },
    management: {
      hero_label: 'GESTION IMMOBILIÈRE',
      hero_title: 'Confiez votre bien à des spécialistes',
      hero_text: 'À partir d\u2019aujourd\u2019hui, nous étendons également nos services à la gestion immobilière complète. Fort de 30 ans d\u2019expertise dans le développement et l\u2019investissement immobilier, Imodeff prend désormais soin de vos biens résidentiels et commerciaux pour que la propriété devienne sereine.',
      cta: 'Obtenir un devis personnalisé',
      services_label: 'NOS SERVICES',
      services_title: 'Une gestion complète, transparente et clé en main',
      services: [
        { title: 'Recherche & sélection de locataires', text: 'Diffusion sur les portails majeurs, visites organisées, vérifications solvabilité et rédaction du bail.' },
        { title: 'Perception & comptabilité', text: 'Perception mensuelle des loyers, indexation, suivi des impayés et décomptes financiers clairs.' },
        { title: 'Entretien technique', text: 'Interventions préventives et correctives avec notre réseau d\u2019artisans agréés.' },
        { title: 'Suivi juridique & fiscal', text: 'Contrats, renouvellements, litiges et conformité annuelle gérés par nos conseillers.' },
        { title: 'Rénovation & valorisation', text: 'Conseils et gestion de projet pour augmenter la valeur et le rendement de votre bien.' },
        { title: 'Portail propriétaire', text: 'Un espace dédié pour consulter loyers, documents et interventions à tout moment.' }
      ],
      process_label: 'COMMENT ÇA MARCHE',
      process_title: 'Un processus simple en quatre étapes',
      process: [
        { step: '01', title: 'Prise de contact', text: 'Nous discutons de votre bien, de vos objectifs et du rendement attendu.' },
        { step: '02', title: 'Audit du bien', text: 'Audit gratuit sur place et positionnement marché pour définir le juste prix.' },
        { step: '03', title: 'Signature du mandat', text: 'Mandat de gestion transparent, adapté à votre bien.' },
        { step: '04', title: 'Gestion clé en main', text: 'Nous nous occupons de tout - vous recevez votre loyer net chaque mois.' }
      ],
      fees_label: 'NOTRE APPROCHE',
      fees_title: 'Une proposition sur mesure',
      fees_text: 'Chaque mandat est construit pour répondre à vos besoins spécifiques et reste entre les mains de confiance de notre famille. Contactez-nous pour recevoir une offre personnalisée.',
      cta_section_title: 'Prêt à nous confier vos clés ?',
      cta_section_text: 'Notre équipe vous répond sous 24 heures avec une proposition adaptée à votre bien.',
      badge_years: '30 ANS',
      badge_tagline: 'De gestion de confiance',
      promise_label: 'NOTRE ENGAGEMENT',
      promise_title: 'Une gestion clé en main, adaptée à votre bien',
      promise_text: 'Une équipe dédiée, des artisans sélectionnés et un processus transparent - pour que posséder devienne serein.',
      commitments: [
        'Reporting trimestriel',
        'Suivi personnalisé',
        'Résiliable à tout moment avec 3 mois de préavis'
      ]
    }
  },
  NL: {
    nav: {
      new_projects: 'NIEUWE PROJECTEN',
      for_sale: 'TE KOOP',
      for_rent: 'TE HUUR',
      who: 'WIE ZIJN WIJ',
      management: 'BEHEER',
      contact: 'CONTACT'
    },
    hero: {
      brand: 'IMODEFF',
      title: 'Commerciële en residentiële projecten in België',
      tagline: 'Family Office · Sinds 1991',
      featured: 'Uitgelicht',
      developer: 'Vastgoedontwikkelaar',
      developer_since: 'SINDS 2010',
      investor: 'Vastgoedinvesteerder',
      investor_since: 'SINDS 1990',
      cta_projects: 'Ontdek onze projecten',
      cta_contact: 'Neem contact op'
    },
    sections: {
      who: 'WIE ZIJN WIJ',
      who_text: 'Imodeff is een vastgoedbedrijf gespecialiseerd in de aankoop, ontwikkeling en beheer van prestigieuze eigendommen in heel België en daarbuiten.',
      vision: 'ONZE VISIE',
      vision_text: 'Onze projecten worden met de grootste zorg geselecteerd en passen in onze visie op duurzaam vastgoed.',
      latest: 'ONZE LAATSTE PROJECTEN',
      activities: 'ONZE ACTIVITEITEN',
      easywork_title: 'Easywork: coworking & business office',
      easywork_text: 'Flexibele coworkingruimtes in een groene omgeving vlakbij de Brusselse ring.',
      view_more: 'Meer bekijken',
      view_project: 'Bekijk project',
      browse_all: 'Alle projecten',
      team: 'ONS TEAM',
      mission: 'ONZE MISSIE',
      mission_text: 'Investeren, ontwikkelen en creëren van vastgoedprojecten met respect voor het architecturaal erfgoed.',
      experience: '30 JAAR ERVARING',
      experience_text: 'Sinds 1991 investeren wij in residentiële en commerciële projecten die bekend staan om hun architectuur en kwaliteit.',
      human_team: 'EEN MENSELIJK TEAM TOT UW DIENST',
      human_team_text: 'Imodeff is een bedrijf op mensenmaat met diepgaande kennis van de vastgoedsector.',
      contact_us: 'CONTACTEER ONS',
      contact_intro: 'Wij beantwoorden graag al uw vragen.',
      find_us: 'ONS VINDEN',
      who_headline: 'Een family office ten dienste van Belgisch vastgoed',
      portfolio_label: 'ONZE PORTFOLIO',
      email_label: 'E-MAIL',
      phone_label: 'TELEFOON',
      address_label: 'ADRES'
    },
    activities: {
      development: 'Vastgoedontwikkeling',
      development_text: 'Door design, technologie en duurzaamheid te combineren, streven onze gebouwen naar maximaal comfort.',
      investment: 'Vastgoedinvestering',
      investment_text: 'Ontdek onze eigendommen in beheer.',
      sales: 'Vastgoedverkoop',
      sales_text: 'Ontdek onze te koop staande eigendommen.',
      rentals: 'Vastgoedverhuur',
      rentals_text: 'Ontdek onze te huur staande eigendommen.'
    },
    form: {
      first: 'Voornaam',
      last: 'Achternaam',
      email: 'E-mail',
      phone: 'Telefoon',
      message: 'Bericht',
      submit: 'Verzenden',
      success: 'Bedankt voor uw bericht!',
      error: 'Er is een fout opgetreden. Probeer opnieuw.'
    },
    footer: {
      contact: 'Contact',
      address: 'Adres',
      copyright: '© 2025 Imodeff. Alle rechten voorbehouden.'
    },
    listing: {
      empty: 'Er zijn nog geen eigendommen in deze categorie.',
      surface: 'Oppervlakte',
      units: 'Eenheden',
      year: 'Jaar',
      architect: 'Architect',
      features: 'Kenmerken',
      request_info: 'Informatie aanvragen',
      back: 'Terug naar projecten',
      details: 'DETAILS',
      not_found: 'Project niet gevonden.',
      status_rented: 'Verhuurd',
      status_sold: 'Verkocht',
      status_price_on_demand: 'Prijs op aanvraag',
      status_on_demand: 'Op aanvraag',
      status_coming_soon: 'Binnenkort beschikbaar',
      status_price_on_request: 'Prijs op aanvraag'
    },
    management: {
      hero_label: 'VASTGOEDBEHEER',
      hero_title: 'Vertrouw uw eigendom toe aan specialisten',
      hero_text: 'Vanaf vandaag breiden we onze diensten uit met volledig vastgoedbeheer. Met 30 jaar expertise in vastgoedontwikkeling en investeringen neemt Imodeff nu ook uw residentiële en commerciële eigendommen onder zijn hoede zodat bezit rustig verloopt.',
      cta: 'Vraag een offerte op maat',
      services_label: 'ONZE DIENSTEN',
      services_title: 'Volledig, transparant en sleutel-op-de-deur beheer',
      services: [
        { title: 'Huurderselectie', text: 'Publicatie op de grootste portalen, bezoeken, solvabiliteitscheck en opstellen van de huurovereenkomst.' },
        { title: 'Inning & boekhouding', text: 'Maandelijkse huurinning, indexatie, opvolging onbetaalde huren en heldere financiële afrekeningen.' },
        { title: 'Technisch onderhoud', text: 'Preventieve en correctieve interventies met ons netwerk van erkende vakmensen.' },
        { title: 'Juridische opvolging', text: 'Contracten, verlengingen, geschillen en jaarlijkse conformiteit door onze juristen.' },
        { title: 'Renovatie & valorisatie', text: 'Advies en projectbeheer om de waarde en het rendement van uw eigendom te verhogen.' },
        { title: 'Eigenaarsportaal', text: 'Een eigen portaal om huren, documenten en interventies op elk moment te raadplegen.' }
      ],
      process_label: 'HOE WERKT HET',
      process_title: 'Een eenvoudig proces in vier stappen',
      process: [
        { step: '01', title: 'Kennismaking', text: 'We bespreken uw eigendom, doelstellingen en verwacht rendement.' },
        { step: '02', title: 'Audit', text: 'Gratis audit ter plaatse en marktpositionering om de juiste huurprijs te bepalen.' },
        { step: '03', title: 'Ondertekening mandaat', text: 'Transparant beheermandaat, op maat van uw eigendom.' },
        { step: '04', title: 'Sleutel-op-de-deur beheer', text: 'Wij regelen alles - u ontvangt maandelijks uw nettohuur.' }
      ],
      fees_label: 'ONZE AANPAK',
      fees_title: 'Een voorstel op maat',
      fees_text: 'Elk mandaat wordt opgemaakt in functie van uw specifieke noden en blijft in de vertrouwde handen van onze familie. Contacteer ons voor een persoonlijk voorstel.',
      cta_section_title: 'Klaar om de sleutels toe te vertrouwen?',
      cta_section_text: 'Ons team antwoordt binnen 24 uur met een voorstel op maat.',
      badge_years: '30 JAAR',
      badge_tagline: 'Vertrouwd beheer',
      promise_label: 'ONZE BELOFTE',
      promise_title: 'Sleutel-op-de-deur beheer, op maat van uw eigendom',
      promise_text: 'Een toegewijd team, geselecteerde vakmensen en een transparant proces - zodat bezitten sereen wordt.',
      commitments: [
        'Driemaandelijkse rapportage',
        'Persoonlijke opvolging',
        'Opzegbaar met 3 maanden opzeg'
      ]
    }
  }
};
